import Cookies from 'universal-cookie'
import yn from 'yn'

export const consentCookies = () => {
  const cookies = new Cookies()
  const zolyConsent = cookies.get('zoly_consent')
  if (yn(process.env.REACT_APP_LGPD_CONSENT)) {
    return (zolyConsent && zolyConsent.publicity === true) || false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/Shared/consentCookies/index.js